import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringLegislationList = api(async function getAuthoringLegislationList({ ids }) {
    if (!Array.isArray(ids) || !ids.length) return []
    return query(
        gql`
            query GetAuthoringLegislationList($ids: [String!]) {
                getAuthoringLegislationList(ids: $ids) {
                    id
                    legacyId
                    redirectId
                    title
                    url
                    description
                    scheduleCount
                    scheduleIds
                    lastModified
                }
            }
        `,
        { ids },
        { returns: "getAuthoringLegislationList" }
    )
})
